import { Utils } from 'versafleet-core';

const pageConstants = {
  JOB_TYPE: 'jobType',
  JOB_DETAIL_EDIT: 'jobDetailEdit',
  TASK_DETAIL_EDIT: 'taskDetailEdit',
};

class JobHelper {
  /**
   * Print by Job ID
   *
   * @param {number} id Job ID
   */
  static print(id) {
    Utils.RequestHelper.openInNewWindow(`/jobs/${id}/print`);
  }
}

JobHelper.PageConstants = pageConstants;
export default JobHelper;
